import customElement from "./decorators/customElement.js";
import event from "./decorators/event.js";
import eventStrict from "./decorators/event-strict.js";
import property from "./decorators/property.js";
import slot from "./decorators/slot.js";
import slotStrict from "./decorators/slot-strict.js";
import bound from "./decorators/bound.js";
import i18n from "./decorators/i18n.js";

export {
	customElement,
	event,
	eventStrict,
	property,
	slot,
	slotStrict,
	bound,
	i18n,
};
